import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slice/authSlice";
import dashboardSlice from "./slice/dashboardSlice";
import orgStructureSlice from "./slice/org-StructureSlice";
import holidaySlice from "./slice/holidaySlice";
import benefitSlice from "./slice/benefitSlice";
import permissionSlice from "./slice/permissionSlice";
import leaveSlice from "./slice/leaveSlice";
import userManagementSlice from "./slice/user-ManagementSlice";
import comapnySlice from "./slice/comapnySlice";
import codeBookSlice from "./slice/code-BookSlice";
import locationSlice from "./slice/locationSlice";
import templatesSlice from "./slice/document-TemplatesSlice";
import employeesSlice from "./slice/employeesSlice";
import notificationsSlice from "./slice/notificationsSlice";

const rootReducer = combineReducers({
  //all slice
  auth: authSlice,
  dashboard: dashboardSlice,
  orgStructure: orgStructureSlice,
  holiday: holidaySlice,
  benifits: benefitSlice,
  permission: permissionSlice,
  leave: leaveSlice,
  comapny: comapnySlice,
  codebook: codeBookSlice,
  usersManagement: userManagementSlice,
  locations: locationSlice,
  templates: templatesSlice,
  employees: employeesSlice,
  notifications: notificationsSlice,
  // Add other slices here
});

export default rootReducer;
